import {Routes} from '@angular/router';
import {EditComponent} from './account/edit.component';
import {routes as patientRoutes} from './patients/patients.routes';
import {routes as inquiryRoutes} from './inquiries/inquiries.routes';
import {routes as administrationRoutes} from './administration/administration.routes';
import {routes as qualityManagementRoutes} from './quality-management/quality-management.routes';
import {StatisticsComponent} from './statistics/statistics.component';
import {PERMISSION} from '@generated-backend-types';
import {routes as timeTrackingRoutes} from './time-tracking/time-tracking.routes';

export const routes: Routes = [
  {
    path: 'account',
    component: EditComponent,
    data: {
      breadcrumb: [
        {label: 'authenticated.account.edit.breadcrumb', translate: true}
      ]
    }
  },
  {
    path: 'statistics',
    component: StatisticsComponent,
    data: {
      allPermissionsNeeded: [PERMISSION.PATIENT_READ_ALL],
      breadcrumb: [
        {
          label: 'authenticated.statistics.breadcrumb',
          translate: true,
          route: '/statistics'
        },
      ]
    }
  },
  {
    path: 'patients',
    children: patientRoutes
  },
  {
    path: 'inquiries',
    children: inquiryRoutes
  },
  {
    path: 'administration',
    children: administrationRoutes
  },
  {
    path: 'quality-management',
    children: qualityManagementRoutes,
  },
  {
    path: 'time-tracking',
    children: timeTrackingRoutes,
  },
];
